import React from "react";
import { Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";
 
const NavTabs = ({ tabs, activeTab, onToggle }) => {
  return (
    <Nav tabs>
      {tabs.map((tab) => (
        <NavItem key={tab.id}>
          <NavLink
            className={classnames({ active: activeTab === tab.id })}
            onClick={() => onToggle(tab.id)}
          >
            {tab.label}
          </NavLink>
        </NavItem>
      ))}
    </Nav>
  );
};
 
export default NavTabs;